export default "__VITE_ASSET__Bre6ybc6__"